import {StudentBoot} from './boot';

// O token do shell dura 30 minutos e e renovado pela sessao Devise em
// POST /:account/app/session. Guardado so em memoria: colocar em localStorage
// nao traria nada (a sessao ja e do navegador) e ampliaria a exposicao.
export class StudentSession {
  private token: string;

  private expiresAt: number;

  private refreshing: Promise<string> | null = null;

  constructor(private readonly boot: StudentBoot) {
    this.token = boot.token;
    this.expiresAt = boot.tokenExpiresAt;
  }

  // Renova com folga: uma query que saisse com o token no ultimo segundo
  // voltaria 401 e derrubaria a tela.
  private get expiringSoon(): boolean {
    const margemSegundos = 120;

    return this.expiresAt - margemSegundos <= Math.floor(Date.now() / 1000);
  }

  public async currentToken(): Promise<string> {
    if (!this.expiringSoon) return this.token;

    return this.refresh();
  }

  // Memoiza a renovacao em voo: o cliente dispara varias operacoes por tela e
  // sem isso cada uma abriria seu proprio POST de refresh.
  public refresh(): Promise<string> {
    this.refreshing ||= this.requestToken().finally(() => {
      this.refreshing = null;
    });

    return this.refreshing;
  }

  private async requestToken(): Promise<string> {
    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

    const response = await fetch(this.boot.refreshPath, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        ...(csrf ? {'X-CSRF-Token': csrf} : {}),
      },
    });

    if (!response.ok) {
      // Sessao Devise caiu: devolve para o login preservando o destino.
      window.location.assign(`/users/sign_in?redirect_to=${encodeURIComponent(window.location.pathname)}`);
      throw new Error('sessao expirada');
    }

    const body = (await response.json()) as {token: string; expiresAt: number};

    this.token = body.token;
    this.expiresAt = body.expiresAt;

    return this.token;
  }
}
